
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { subscribersFields } from "@/components/players/fields/subscribersFields";
import SelectSubscribersModal from "@/components/players/modals/SelectSubscribersModal.vue";
import PlayerMonitorSubscriberRemoveModal from "@/components/players/modals/PlayerMonitorSubscriberRemoveModal.vue";
import { MonitorSubscriber, SubscriberType } from "@/services/players/types";
@Component({
    components: { PlayerMonitorSubscriberRemoveModal, SelectSubscribersModal }
})
export default class PlayerMonitorSubscribers extends Vue {
    @Prop() subscribers!: Array<MonitorSubscriber>;
    @Prop() collapseState!: boolean;
    // local state
    localSubscribers = [] as Array<MonitorSubscriber>;
    searchQuery = "";
    fields = subscribersFields;
    localCollapseState = true;
    subscriberType = SubscriberType;

    mounted() {
        this.localCollapseState = this.collapseState;
        this.localSubscribers = this.subscribers;
    }

    created() {
        this.localCollapseState = this.collapseState;
        this.localSubscribers = this.subscribers;
    }

    @Watch("subscribers")
    onPropertyChanged() {
        this.localSubscribers = this.subscribers;
    }

    get existingSubscribers(): Array<MonitorSubscriber> {
        return this.subscribers;
    }

    // computed
    get filteredData() {
        return this.localSubscribers && this.localSubscribers
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.email.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    openSubscribersPrompt() {
        (this.$refs.selectSubscribers as any).open(true);
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "PlayerMonitorSubscribers.vue", state: state });
    }

    onSubscribersSelected(newSubscribers: MonitorSubscriber[]) {
        debugger;
        const subscribersToBeAdded = newSubscribers
            .filter(x => !this.localSubscribers.map(x => x.id).includes(x.id));
        if (subscribersToBeAdded.length > 0) {
            this.localSubscribers = this.localSubscribers.concat(subscribersToBeAdded);
        }
    }

    removeSubscriber(subscriber: MonitorSubscriber) {
        (this.$refs.removeSubscriber as any).open(subscriber.id, subscriber.name);
    }

    onRemoved(id: string) {
        const item = this.localSubscribers.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localSubscribers = this.localSubscribers.filter(x => x.id !== id);
    }

    // events
    emitData() {
        this.$emit("subscribersUpdated", this.localSubscribers);
    }
}
